/* v8 ignore start */
import {JsonModel} from "@/lib/core/jsonModel";
import {TRGB} from "@/lib/lottie/layers/lottieTextLayerModel";
import {LottieTextDocumentModel} from "@/lib/lottie/text/lottieTextDocumentModel";

export class LottieTextDocumentKeyFrameModel extends JsonModel<LottieTextDocumentKeyFrameModel.IJson> {
  public get text(): string {
    return this.lottieTextDocumentModel.text;
  }

  public get lottieTextDocumentModel(): LottieTextDocumentModel {
    return new LottieTextDocumentModel(this.json.s);
  }

  public replaceTextWithAutoFit(newText: string, maxWidth: number, maxHeight: number): this {
    return this.update({
      s: this.lottieTextDocumentModel.replaceTextWithAutoFit(newText, maxWidth, maxHeight).toObject(),
    });
  }

  public changeColor(color: TRGB): this {
    return this.update({
      s: this.lottieTextDocumentModel.changeColor(color).toObject(),
    });
  }
}

export namespace LottieTextDocumentKeyFrameModel {
  export interface IJson {
    // Start
    s: LottieTextDocumentModel.IJson;

    // Time
    t: number;
  }
}
/* v8 ignore stop */
